import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {useSelector} from 'react-redux';
import {Icon} from 'front-onceforall-core';
import {openOrSaveFile} from '../../../../utils/http';
import authenticationService from '../../../../services/authentication/AuthenticationService';
import enrollmentService from '../../../../services/enrollment';

function DownloadAccessCodeView({invitation: {accessCode, invitationId}}) {
  const {organisationId} = useSelector(state => state.organisation);

  if (!accessCode) {
    return null;
  }

  function handleDownloadAccessCode() {
    authenticationService.authRedirect(enrollmentService.general.downloadAccessCode(organisationId, invitationId))
      .then(authUrl => openOrSaveFile(authUrl, 'pdf'));
  }

  return (
    <button
      data-id="download-button"
      className="small secondary flex-container"
      onClick={handleDownloadAccessCode}
    >
      <Icon icon="download"/>
      <Translate value="subcontractor.accessCode.download"/>
    </button>
  );
}

DownloadAccessCodeView.propTypes = {
  invitation: PropTypes.object.isRequired
};

export default DownloadAccessCodeView;
